import AxiosConfig from './LensAxiosConfig'
import firebase from '../config/FirebaseConfig'
import { providerKeyMap } from '@/utils/lens/dataSourceUtils'

const getAdUniqueMetrics = async (lensId, adAccountId, query) => {
  const { Aa: token } = firebase.auth().currentUser

  const { adIds, platform = 'meta', startDate, endDate } = query
  const { data } = await AxiosConfig.post(
    `/ads/unique-metrics/${lensId}`,
    {
      account_id: adAccountId,
      provider: providerKeyMap[platform],
      ad_ids: adIds,
      start_date: startDate,
      end_date: endDate
    },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

export default {
  getAdUniqueMetrics
}